import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable";
import {
  get_item_list,
  get_branchstock,
  AddBranchStock,
  AdjustBranchStock,
} from "../../services/projectApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetUserInfo } from "../../utils/permissionChecker";
import { get_branch_data } from "../../services/employeeApi";
import { toast } from "react-toastify";
import { Modal, Row, Form, Col, Button, Spinner } from "react-bootstrap";
const BranchStockAssignment = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
    setFormError("");
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsUpdateMode(false);
  };
  const initialFormState = {
    item_id: "",
    quantity: "",
    branch_id: "",
    reference_id: "",
    adjustment_type: "",
  };
  const [formData, setFormData] = useState(initialFormState);
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      adjustment_type: "",
    }));
  }, [isUpdateMode]);
  const RegisterBranchStockMutation = useMutation(async (newData) => {
    try {
      let result;
      if (isUpdateMode) {
        result = await AdjustBranchStock(newData);
      } else {
        result = await AddBranchStock(newData);
      }
      if (result) {
        queryClient.invalidateQueries("get_branch_branch_stock");
        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setFormData(initialFormState);
        handleCloseModal();
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  });
  const AdjustmentTypes = [
    { id: "SALE", label: "Sale", direction: "DECREASE" },
    { id: "TRANSFER_OUT", label: "Transfer to other", direction: "DECREASE" },
    { id: "WASTAGE", label: "Wastage", direction: "DECREASE" },

    { id: "RECEIVE", label: "Add new stock", direction: "INCREASE" },
    { id: "TRANSFER_IN", label: "Accept transfer", direction: "INCREASE" },
    {
      id: "RETURN_FROM_EMPLOYEE",
      label: "Return from employee",
      direction: "INCREASE",
    },
  ];
  const { data, isLoading, isError, error } = useQuery(
    ["get_branch_employee_stock"],
    async () => {
      const getBranch = await get_branch_data();
      const branchStock = await get_branchstock();
      const getitem = await get_item_list();
      return {
        branche: getBranch,
        branchStock: branchStock.data,
        item: getitem.data,
      };
    }
  );

  const branchData = useMemo(() => {
    return data?.branche || [];
  }, [data]);

  const BranchstockData = useMemo(() => {
    return data?.branchStock || [];
  }, [data]);
  const itemData = useMemo(() => {
    return data?.item || [];
  }, [data]);

  const filteredAdjustmentTypes = useMemo(() => {
    if (isUpdateMode) {
      return AdjustmentTypes.filter((t) => t.direction === "DECREASE");
    }
    return AdjustmentTypes.filter((t) => t.direction === "INCREASE");
  }, [isUpdateMode]);
  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (isError) {
    return <div>Error: {error.message}</div>;
  }

  const Update = (event, data) => {
    event.preventDefault();
    setIsUpdateMode(true);
    handleShowModal();
    setFormData({
      item_id: data.item_id,
      quantity: 0,
      branch_id: data.branch_id,
      reference_id: data.id,
      adjustment_type: "",
    });
  };
  const handleButtonSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.item_id ||
      !formData.branch_id ||
      !formData.quantity ||
      !formData.adjustment_type
    ) {
      setFormError("Pease fill all fields are required ");
      return;
    }
    try {
      setIsSubmitting(true);
      await RegisterBranchStockMutation.mutate(formData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  const stockTableColumns = [
    {
      header: "branch",
      accessorKey: "branch_name",
    },
    {
      header: "item",
      accessorKey: "item_name",
    },
    {
      header: "quantity",
      accessorKey: "current_quantity",
    },
    {
      header: "unit",
      accessorKey: "item_units",
    },
    {
      header: "Action",
      accessor: "id",
      cell: (row) => (
        <div className="d-flex justify-content align-items-center">
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => Update(e, row.row.original)}
          >
            {t("Adjust")}
          </Button>
        </div>
      ),
    },
  ];
  return (
    <>
      <BasicTable
        data={BranchstockData}
        columns={stockTableColumns}
        title={`Branch Stock Managment`}
        actionButton={
          <Button
            variant="btn btn-info btn-sm"
            onClick={() => handleShowModal()}
          >
            {t("add_stock")}
          </Button>
        }
      />
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {isUpdateMode ? "Add new stock  report" : "Add stock to branch "}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg="12">
                <Form.Group>
                  <div className="col-md-12 mb-3">
                    <Form.Group>
                      <Form.Label
                        htmlFor="inputPosition"
                        className="font-weight-bold text-muted"
                      >
                        {t("branch")}
                      </Form.Label>
                      <select
                        id="inputPosition"
                        className="form-select form-control choicesjs"
                        value={formData.branch_id}
                        onChange={(e) => handleInputChange(e, "branch_id")}
                      >
                        <option value="" hidden disabled>
                          Select Branches
                        </option>
                        {branchData.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  </div>
                  <div className="col-md-12 mb-3">
                    <Form.Label
                      htmlFor="inputPosition"
                      className="font-weight-bold text-muted"
                    >
                      {t("item")}
                    </Form.Label>
                    <select
                      id="inputPosition"
                      className="form-select form-control choicesjs"
                      value={formData.item_id}
                      onChange={(e) => handleInputChange(e, "item_id")}
                    >
                      <option value="" hidden disabled>
                        Select Item
                      </option>
                      {itemData?.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-12 mb-3">
                    <Form.Group>
                      <Form.Label
                        htmlFor="inputPosition"
                        className="font-weight-bold text-muted"
                      >
                        {t("Taype")}
                      </Form.Label>
                      <select
                        id="inputPosition"
                        className="form-select form-control choicesjs"
                        value={formData.adjustment_type}
                        onChange={(e) =>
                          handleInputChange(e, "adjustment_type")
                        }
                      >
                        <option value="" hidden disabled>
                          Select adjustment type
                        </option>
                        {filteredAdjustmentTypes.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.label}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  </div>

                  <div className="col-md-12 mb-3">
                    <Form.Label className="text-secondary">Quantity</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter quantity"
                      value={formData.quantity}
                      onChange={(e) => handleInputChange(e, "quantity")}
                    />
                  </div>
                  <p className="text-danger"> {formError}</p>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {isSubmitting ? (
            <Button className="btn btn-info">
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="visually-hidden">Sending...</span>
            </Button>
          ) : (
            <Button
              className="btn btn-info"
              onClick={(e) => handleButtonSubmit(e)}
            >
              {isUpdateMode ? "Update" : "Register"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BranchStockAssignment;
